const iconList = [
    'el-icon-s-home',
    'el-icon-cpu',
    'el-icon-link',
    'el-icon-c-scale-to-original',
    'el-icon-date',
    'el-icon-folder',
    'el-icon-folder-opened',
    'el-icon-tickets',
    'el-icon-document-remove',
    'el-icon-document-copy',
    'el-icon-document-checked',
    'el-icon-reading',
    'el-icon-data-line',
    'el-icon-data-board',
    'el-icon-data-analysis',
    'el-icon-collection',
    'el-icon-notebook-1',
    'el-icon-notebook-2',
    'el-icon-wallet',
    'el-icon-discount',
    'el-icon-chat-line-square',
    'el-icon-present',
    'el-icon-bank-card',
    'el-icon-ice-cream-round',
    'el-icon-delete-location',
    'el-icon-location-outline',
    'el-icon-place',
    'el-icon-discover',
    'el-icon-copy-document',
    'el-icon-stopwatch',
    'el-icon-postcard',
    'el-icon-set-up',
    'el-icon-potato-strips',
    'el-icon-lollipop',
    'el-icon-ice-cream-square',
    'el-icon-chat-line-round',
    'el-icon-s-management',
    'el-icon-s-marketing',
    'el-icon-s-order',
    'el-icon-s-flag',
    'el-icon-s-promotion',
    'el-icon-s-goods',
    'el-icon-s-ticket',
    'el-icon-s-tools',
    'el-icon-s-claim',
    'el-icon-s-comment',
    'el-icon-s-shop',
    'el-icon-s-check',
    'el-icon-printer',
    'el-icon-magic-stick',
    'el-icon-mobile-phone',
    'el-icon-microphone',
    'el-icon-headset',
    'el-icon-arrow-left',
    'el-icon-arrow-right',
    'el-icon-arrow-down',
    'el-icon-arrow-up',
    'el-icon-loading',
    'el-icon-search',

    'el-icon-check',
    'el-icon-lock',
    'el-icon-edit',
    'el-icon-share',
    'el-icon-phone',
    'el-icon-video-camera',
    'el-icon-picture',
    'el-icon-camera',
    'el-icon-warning',
    'el-icon-info',
    'el-icon-close',
    'el-icon-caret-right',
    'el-icon-caret-left',
    'el-icon-mobile',
    'el-icon-cloudy',
    'el-icon-document',
    'el-icon-folder-add',
    'el-icon-folder-delete',
    'el-icon-delete',
    'el-icon-edit-outline',
    'el-icon-zoom-in',
    'el-icon-zoom-out',

    'el-icon-error',
    'el-icon-success',
    'el-icon-message',
    'el-icon-bell',
    'el-icon-sunrise',
    'el-icon-sunset',
    'el-icon-time',
    'el-icon-phone-outline',
    'el-icon-mic',
    'el-icon-key',
    'el-icon-question',


    'el-icon-document-add',
    'el-icon-view',
    'el-icon-refresh',

    'el-icon-download',

    'el-icon-refresh-right',
    'el-icon-refresh-left',

    'el-icon-watch',
]
export default iconList
